import React from "react";

import { Icon, IconSize } from "@gaming/xds-react-js";
import { Accept } from "@gaming/xds-react-js-icons";

import { useStrings } from "../../../../localization/localizationHelpers";

import { LandingCtaPlacements, useLandingCta } from "../../useLandingCta";
import * as styles from "./PartnerCtaSection.module.css";

export const PartnerCtaSection = () => {
  const handleJoin = useLandingCta(LandingCtaPlacements.join);

  const [title, description, bullet1, bullet2, bullet3, buttonLabel] = useStrings(
    "landingCtaTitle",
    "landingCtaDescription",
    "landingCtaBullet1",
    "landingCtaBullet2",
    "landingCtaBullet3",
    "landingCtaButton"
  );

  const bullets = [bullet1, bullet2, bullet3];

  return (
    <section className={styles.section}>
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.description}>{description}</p>
      <ul className={styles.bulletList}>
        {bullets.map(bullet => (
          <li key={bullet} className={styles.bullet}>
            <Icon icon={Accept} iconSize={IconSize.Small} />
            <span>{bullet}</span>
          </li>
        ))}
      </ul>
      <button className={styles.joinButton} onClick={handleJoin}>
        {buttonLabel}
      </button>
    </section>
  );
};
